import { drawing } from '@progress/kendo-drawing';
import { VisualBase } from './VisualBase.js';
import { MarkerPathMixin } from './MarkerPathMixin.js';
import { createSegment } from './utils.js';
import { deepExtend } from '../utils/deep-extend.js';

class Polyline extends VisualBase {
    constructor(options) {
        options = deepExtend({ points: [] }, options);
        super(options);
        this._capMap = MarkerPathMixin._capMap;
        this.container = new drawing.Group();
        this._getPath = MarkerPathMixin._getPath.bind(this);
        this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
        this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
        this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
        this._createMarker = MarkerPathMixin._createMarker.bind(this);
        this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
        this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
        this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
        this._initPath();
        this._createMarkers();
    }
    drawingContainer() {
        return this.container;
    }
    points(points) {
        const options = this.options;
        if (points) {
            options.points = points;
            this._updatePath();
        }
        else {
            return options.points;
        }
    }
    redraw(options) {
        if (options) {
            const points = options.points;
            super.redraw.call(this, options);
            if (points && this._pointsDiffer(points)) {
                this.points(points);
                this._redrawMarkers(true, options);
            }
            else {
                this._redrawMarkers(false, options);
            }
        }
    }
    _initPath() {
        const options = this.options;
        this.drawingElement = new drawing.Path({
            stroke: options.stroke
        });
        this._fill();
        this.container.append(this.drawingElement);
        if (options.points) {
            this._updatePath();
        }
    }
    _pointsDiffer(points) {
        const currentPoints = this.options.points;
        let differ = currentPoints.length !== points.length;
        if (!differ) {
            for (let i = 0; i < points.length; i++) {
                if (currentPoints[i].x !== points[i].x || currentPoints[i].y !== points[i].y) {
                    differ = true;
                    break;
                }
            }
        }
        return differ;
    }
    _updatePath() {
        const drawingElement = this.drawingElement;
        const options = this.options;
        const points = options.points;
        const segments = [];
        let point;
        for (let i = 0; i < points.length; i++) {
            point = points[i];
            segments.push(createSegment(point.x, point.y));
        }
        drawingElement.segments.elements(segments);
    }
}

export { Polyline };
